export default __webpack_public_path__ + "static/media/press-start.cc9ac4fc.wav";